import { render, staticRenderFns } from "./HomeManagingPartner.vue?vue&type=template&id=74f84190&scoped=true&"
import script from "./HomeManagingPartner.vue?vue&type=script&lang=js&"
export * from "./HomeManagingPartner.vue?vue&type=script&lang=js&"
import style0 from "./HomeManagingPartner.vue?vue&type=style&index=0&id=74f84190&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f84190",
  null
  
)

export default component.exports